import Container from "@vfuk/core-container";
import Heading from "@vfuk/core-heading";
import Icon from "@vfuk/core-icon";
import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";
import styled from "styled-components";
import type { IconProps } from "@vfuk/core-icon/dist/Icon.types";
import { Stack } from "../Stack";
import { Link } from "react-router-dom";

interface IconCardProps {
  icon: IconProps["name"];
  title: string;
  desc: string;
  to: string;
}

const LinkNoUnderline = styled(Link)`
  text-decoration: none;
`;

const IconCard = ({ icon, title, desc, to }: IconCardProps) => {
  return (
    <LinkNoUnderline to={to}>
      <Container elevation>
        <Stack justifyContent="space-between">
          <Stack>
            <Icon group="midLight" name={icon} />
            <Spacing spacingLevel={{ left: 4 }}>
              <Heading noMargin weight={2} level={5}>
                {title}
              </Heading>
              <Paragraph appearance="secondary">{desc}</Paragraph>
            </Spacing>
          </Stack>
          <Icon
            group="system"
            appearance="secondary"
            size={4}
            name="chevron-right"
          />
        </Stack>
      </Container>
    </LinkNoUnderline>
  );
};

export default IconCard;
